import Voting, { TYPE_BINGO, TYPE_BEST_PLAYER, TYPE_MATCH_RESULT } from './base';
import BingoVoting from './bingo';
import BestPlayerVoting from './bestPlayer';
import MatchResultVoting from './matchResult';
import {utility} from '../../utilites';
import {} from './'

export const loadVotings = async function(eventId: string) {
  let votings = await utility.networkLayer.getJson(Voting.path.replace(':eventId', eventId));
  let votingPromises: Promise<Voting>[] = votings
    .map(data => votingFactory(data.type, data))
    .map(voting => voting instanceof Voting ? voting.fetch() : voting);


  return Promise.all(votingPromises);
};

export function votingFactory(type, data): Voting {
  switch (type) {
    case TYPE_BINGO:
      return new BingoVoting(data);
    case TYPE_BEST_PLAYER:
      return new BestPlayerVoting(data);
    case TYPE_MATCH_RESULT:
      return new MatchResultVoting(data);
    default:
      return new Voting(data);
  }
}

export default loadVotings;



// WEBPACK FOOTER //
// ./src/api/voting/loader.ts